import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { TerminateMultiAssetWizardEffects } from './effects';
import * as fromTerminateMultiAssetWizard from './reducer';

export function provideTerminateMultiAssetWizardStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromTerminateMultiAssetWizard.terminateMultiAssetWizardFeatureKey, fromTerminateMultiAssetWizard.reducer),
    provideEffects(TerminateMultiAssetWizardEffects),
  ]);
}
